import imageCompression from 'browser-image-compression';

export const compressImage = async (file, customOptions = {}) => {
  const defaultOptions = {
    maxSizeMB: 5,
    maxWidthOrHeight: 1600,
    useWebWorker: true,
  };

  const options = { ...defaultOptions, ...customOptions };

  try {
    console.log(`Original file size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);

    if (file.size <= options.maxSizeMB * 1024 * 1024) {
      console.log('File already under size limit, skipping compression');
      return file;
    }

    const compressedFile = await imageCompression(file, options);
    console.log(`Compressed file size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
    return compressedFile;
  } catch (error) {
    console.error('Error compressing image:', error);
    return file;
  }
};

export const compressMultipleImages = async (files, options = {}) =>
  Promise.all(files.map((file) => compressImage(file, options)));
